import FileListItem from "./FileListItem";
import { Table } from "react-bootstrap";

const FileListTable = ({
  files,
  deleteFile,
  showFile,
  handleFileFunction,
  moveFile = null,
  /** batch mode: a checkbox column, rows toggle on click */
  selectable = false,
  isSelected = () => false,
  onToggleSelect = null,
}) => {
  return (
    <Table className="table align-middle table-nowrap table-hover mb-0 table">
      <thead>
        <tr>
          {selectable && <th scope="col" style={{ width: 36 }} />}
          <th scope="col">Name</th>
          <th scope="col">Date</th>
          <th scope="col">Size</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {files.map((file, index) => {
          return (
            <FileListItem
              key={`${file._source ?? ""}-${file.id}`}
              file={file}
              moveFile={moveFile}
              deleteFile={() => deleteFile(index, file)}
              viewFile={showFile}
              handleFileFunction={handleFileFunction}
              index={index}
              selectable={selectable}
              selected={selectable && isSelected(file)}
              onToggleSelect={
                selectable && typeof onToggleSelect === "function"
                  ? (event) => onToggleSelect(file, index, event?.shiftKey)
                  : null
              }
            />
          );
        })}
      </tbody>
    </Table>
  );
};
export default FileListTable;
